import { render, staticRenderFns } from "./SelosRegistro.vue?vue&type=template&id=1233df2b&scoped=true&"
import script from "./SelosRegistro.vue?vue&type=script&lang=js&"
export * from "./SelosRegistro.vue?vue&type=script&lang=js&"
import style0 from "./SelosRegistro.vue?vue&type=style&index=0&id=1233df2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1233df2b",
  null
  
)

export default component.exports